export const color = {
  black1: '#2E404D',
  black2: '#68747D',
  black3: '#869CAC',
  gray1: '#C0CBD3',
  gray2: '#F3F8FC',
  gray3: '#EFF3F6',
  gray4: '#E5EBF0',
  blue1: '#237ABA',
  blue2: '#07649F',
  blue3: '#B2D0E6',
  green: '#2BA633',
  orange: '#D37F15',
  red: '#CF3333',
  yellow: '#FFFBEA',
  white: '#FFFFFF',
  black: '#000000',
  shadow1: 'rgba(190,200,210,0.2)',

  background: '#121620',
  golden: '#f8c106',
  cream: '#decfaa',
  purple: '#3d1272',
  violet: '#714fb1',
  lightBrown: '#c1a78a',
  lightGrey: '#2f354a',
  darkBlue: '#121620',
};
